var _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGoogle(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    className: "sc-eqUAAy cMqsAc mx-icon ThirdPartyLogin_itemIcon__xyvJl",
    focusable: "false",
    width: "1em",
    height: "1em",
    fill: "currentColor",
    "aria-hidden": "true",
    viewBox: "0 0 1024 1024",
    "data-icon": "Icongoogle1",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M977.454545 565.434182a539.927273 539.927273 0 0 0-8.192-94.114909h-447.767272v178.269091h256.465454A214.946909 214.946909 0 0 1 683.101091 790.341818v115.805091h153.041454C925.789091 825.530182 977.454545 706.373818 977.454545 565.434182z",
    fill: "#4285F4"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M521.588364 1018.042182c128.093091 0 235.985455-40.96 314.647272-111.802182L683.287273 790.434909c-42.635636 28.113455-97.373091 44.218182-161.605818 44.218182a281.879273 281.879273 0 0 1-163.560728-52.875636A284.858182 284.858182 0 0 1 255.069091 643.444364H97.28v119.342545c80.709818 156.392727 244.829091 255.255273 424.308364 255.255273z",
    fill: "#34A853"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M254.882909 643.444364a271.080727 271.080727 0 0 1 0-177.245091V346.949818H97.093818a452.701091 452.701091 0 0 0 0 415.837091l157.789091-119.342545z",
    fill: "#FBBC04"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M521.588364 274.990545a261.399273 261.399273 0 0 1 182.085818 69.53891l135.540363-132.189091A462.661818 462.661818 0 0 0 521.588364 91.694545C342.109091 91.694545 177.803636 190.370909 97.28 346.949818L255.069091 466.199273a284.858182 284.858182 0 0 1 102.958545-138.24 281.879273 281.879273 0 0 1 163.560728-52.968728z",
    fill: "#EA4335"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGoogle);
export default __webpack_public_path__ + "static/media/google.4a3758fc9035f43865ff2890d8dbbc5f.svg";
export { ForwardRef as ReactComponent };